module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('section', {
    staticClass: "content",
    staticStyle: {
      "overflow-x": "hidden"
    },
    attrs: {
      "role": "main",
      "aria-label": "תוכן"
    }
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content single-content"
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img2srcD,
    staticClass: "fillImgBack",
    attrs: {
      "alt": "ממשו את התשוקה שלכם למוסיקה",
      "src": _vm.img2srcD
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img2src,
    staticClass: "fillImgFront",
    attrs: {
      "alt": "תנו לנו לדאוג לכל הפרטים",
      "src": _vm.img2src
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds double-textbounds"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    attrs: {
      "role": "heading",
      "aria-level": "2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text1header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text1)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text2header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text2)
    }
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "info-content single-content"
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img3srcD,
    staticClass: "fillImgBack",
    attrs: {
      "alt": "אתם בידיים טובות",
      "src": _vm.img3srcD
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img3src,
    staticClass: "fillImgFront",
    attrs: {
      "alt": "הגיע הזמן להוציא את הגיטרה מהארון",
      "src": _vm.img3src
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds double-textbounds"
  }, [_c('div', {
    staticClass: "textbox textbox-left double-textbounds"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text3header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text3)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text4header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text4)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('v-link', {
    attrs: {
      "href": "/rhythm"
    }
  }, [_c('img', {
    attrs: {
      "alt": "רישום לאודישן",
      "src": "images/comeplay.png"
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content single-content textbox-bounds-unbound",
    attrs: {
      "id": "someAnnoyingDiv"
    }
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img5srcD,
    staticClass: "fillImgBack",
    attrs: {
      "alt": "לנגן בלהקה או לשיר במקהלה?",
      "src": _vm.img5srcD
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img5src,
    staticClass: "fillImgFront",
    attrs: {
      "alt": "לנגן בלהקה או לשיר במקהלה?",
      "src": _vm.img5src
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds-unbound"
  }, [_c('div', {
    staticClass: "textbox single-content textbox-left embedVideoMargin"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text5header)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text5)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "embeded-player single-content"
  }, [_c('div', {
    attrs: {
      "id": "embeded-player"
    }
  }, [_c('div', {
    staticClass: "plyr__video-embed",
    attrs: {
      "id": "player2"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "z-index": "8"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/videoseries?list=PLkEmjSM87aKrcl-z0EZgvQwPHiITsp9Vb&autoplay=0&iv_load_policy=3&modestbranding=0&playsinline=1showinfo=0&rel=0&enablejsapi=1?&autohide=1&controls=1&mute=0&origin=https://yardbands.com",
      "allowfullscreen": "",
      "allowtransparency": "",
      "id": "yuPlayer2"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content double-content"
  }, [_c('div', {
    staticClass: "fill double-content"
  }, [_c('img', {
    key: _vm.img6srcD,
    staticClass: "fillImgBack",
    attrs: {
      "alt": "איך זה עובד?",
      "src": _vm.img6srcD
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img6src,
    staticClass: "fillImgFront",
    attrs: {
      "alt": "איך זה עובד?",
      "src": _vm.img6src
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds double-textbounds"
  }, [_c('div', {
    staticClass: "textbox textbox-left textbox-centerlized"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text centered"
  }, [_c('h3', {
    attrs: {
      "id": "working"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6header)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph bordered"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6subheader)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6_1)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "downward-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph bordered"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6subheader2)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6_2)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "downward-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-box-paragraph bordered"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6subheader3)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.home_text6_3)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "comeplay-btn"
  }, [_c('v-link', {
    attrs: {
      "href": "/rhythm"
    }
  }, [_c('img', {
    attrs: {
      "alt": "רישום לאודישן",
      "src": "images/comeplay.png"
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content double-content2",
    attrs: {
      "id": "FAQS"
    }
  }, [_c('div', {
    staticClass: "fill double-content2"
  }, [_c('img', {
    key: _vm.img8srcD,
    staticClass: "fillImgBack",
    attrs: {
      "alt": "שאלות נפוצות",
      "src": _vm.img8srcD
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    key: _vm.img8src,
    staticClass: "fillImgFront",
    attrs: {
      "alt": "שאלות נפוצות",
      "src": _vm.img8src
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds double-textbounds"
  }, [_c('div', {
    staticClass: "textbox textbox-right"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  }, [_c('div', {
    staticClass: "text-box-paragraph"
  }, [_c('h3', [_vm._v("שאלות נפוצות")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('FAQ', {
    key: _vm.faq
  })], 1)], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09c369f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 99
// module chunks = 0